<template>
  <div class="isis-page__header md-layout">
    <div class="md-layout-item md-size-100">
      <div class="nav-link" @click="goToPreviousPage()">
        <i class="fas fa-chevron-left"></i>
        <span>{{ $t("task_management.add_individual_task") }}</span>
      </div>
    </div>
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <SubtaskForm mode="add" type="individual"></SubtaskForm>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import SubtaskForm from "../Component/SubtaskForm";
import { hasHistory } from "@/helpers/utils";
export default {
  components: {
    SubtaskForm
  },
  methods: {
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    }
  }
};
</script>
<style scoped lang="scss">
.header-title {
  font-weight: 500;
  font-size: 26px;
  line-height: 36px;
  letter-spacing: 0.18px;
  color: #1b1f22;
  cursor: pointer;
}
</style>
